const numberOfInteraction = (messages) => {
    let cpt = 0;
    let currentType = null;
    for (let i = 0; i < messages.length; i++) {
        let mess = messages[i];
        if (mess.human == 0) continue;
        cpt++;
        currentType = mess.human;
    }

    return cpt;
}

export default numberOfInteraction